import React from 'react';
import { motion } from 'framer-motion';
import { ServicePageHero } from '../components/ServicePageHero';
import { CTASection } from '../components/CTASection';
import { Link } from 'react-router-dom';
export function ChillerHire() {
  const features = ['F-GAS certified technicians', 'Process & ambient cooling', 'Complete end-to-end service', 'UK-wide logistics', 'Continuous 24/7 monitoring', 'Latest generation hardware'];
  return <main className="flex-grow" data-id="element-270">
      <ServicePageHero title="Industrial Chiller Hire" subtitle="High-capacity process and ambient cooling systems engineered for critical temperature regulation." data-id="element-271" />

      <section className="py-20 bg-white" data-id="element-272">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-274">
            {/* Content Left */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-2/3" data-id="element-275">
              <h2 className="text-3xl font-heading font-bold text-brand-navy mb-6" data-id="element-276">
                Precision Temperature Control
              </h2>

              <div className="space-y-6 text-brand-slate text-lg leading-relaxed mb-10" data-id="element-277">
                <p data-id="element-278">
                  Utilizing REFCOM F-GAS accredited technicians and
                  latest-generation hardware, we provide a highly rated,
                  dependable chiller rental service. You can rely on our
                  organization to maintain your critical cooling parameters.
                </p>
                <p data-id="element-279">
                  Our contemporary industrial chillers are purpose-built for the
                  rental sector, excelling in both manufacturing process cooling
                  and large-scale comfort applications. If the exact
                  specifications required are unknown, our engineering
                  consultants will analyze your site and recommend the optimal
                  cooling architecture.
                </p>
                <p data-id="element-280">
                  We execute a <strong data-id="element-281">complete end-to-end hire service</strong>
                  , handling the entire lifecycle from initial scoping to final
                  activation. Our personnel function as a dedicated extension of
                  your facilities management team for the project's duration.
                </p>
                <p data-id="element-282">
                  Common deployment scenarios include: Disaster Recovery,
                  Pharmaceutical Manufacturing, Building HVAC Support,
                  Industrial Process Cooling, Sub-Zero Applications, and Food
                  Production environments.
                </p>
                <p data-id="element-283">
                  Our logistics network covers the entirety of Great Britain. We
                  maintain a <strong data-id="element-284">continuous 24/7 support structure</strong>{' '}
                  to ensure uninterrupted operation throughout your rental
                  period.
                </p>
              </div>

              <h3 className="text-xl font-heading font-bold text-brand-navy mb-6" data-id="element-285">
                System Capabilities
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-286">
                {features.map((feature, i) => <span key={i} className="bg-brand-light border border-gray-200 text-brand-navy px-4 py-2 rounded-full text-sm font-medium" data-id="element-287">
                    {feature}
                  </span>)}
              </div>
            </motion.div>

            {/* Sidebar Right */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="lg:w-1/3 w-full sticky top-24" data-id="element-288">
              <div className="bg-brand-navy p-8 rounded-xl text-white mb-8" data-id="element-289">
                <h3 className="text-xl font-heading font-bold mb-4" data-id="element-290">
                  Quick Inquiry
                </h3>
                <p className="text-sm text-gray-400 mb-6" data-id="element-291">
                  Need a chiller urgently? Call our 24/7 dispatch team.
                </p>
                <a href="tel:08004647025" className="block w-full text-center bg-brand-amber text-brand-navy font-bold py-3 rounded hover:bg-white transition-colors" data-id="element-292">
                  0800 464 7025
                </a>
              </div>
              <img src="https://rapidenergy.co.uk/wp-content/uploads/2025/04/360kW-Heat-Pump-Chiller-555px-by-555px.webp" alt="Industrial Chiller Unit" className="rounded-xl shadow-lg w-full object-cover" data-id="element-293" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Other Services Strip */}
      <section className="bg-brand-light py-8 border-y border-gray-200" data-id="element-294">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-295">
          <span className="text-brand-slate font-medium" data-id="element-296">Explore more:</span>
          <Link to="/boiler-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-297">
            Temporary Boilers
          </Link>
          <Link to="/cooling-hire" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-298">
            Cooling Systems
          </Link>
          <Link to="/ancillaries" className="text-brand-navy font-bold hover:text-brand-amber transition-colors" data-id="element-299">
            Ancillary Equipment
          </Link>
        </div>
      </section>

      <CTASection data-id="element-300" />
    </main>;
}